import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  iamAccountEntityRaw,
  IAMAccountEntityRaw
} from "@youm-front/iam-account/domain";

export class IAMAccountUpdateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountUpdateResponseDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountUpdateResponseDTORaw) {
    JsonSchemaValidator.validate(IAMAccountUpdateResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["account"],
      properties: {
        account: iamAccountEntityRaw
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountUpdateResponseDTORaw {
  account: IAMAccountEntityRaw;
}
